export const reportAttendanceOperatorText = {
  titleText: 'Absensi Report',
  headTitleText: 'Absensi',
  buttonExportText: 'Export',
  monthYearPickerPlaceholder: 'Pilih Bulan',
};
